import { Box, Heading, Input, Select, Stack } from "@chakra-ui/react";
import { __ } from "@wordpress/i18n";
import React from "react";
import { useFormContext } from "react-hook-form";
import { IntegrationsSettingsMap } from "../../../types";
import FormTwoColumn from "./FormTwoColumn";

type Props = {
	data?: IntegrationsSettingsMap;
};

const Integrations: React.FC<Props> = (props) => {
	const { register } = useFormContext();

	return (
		<Box>
			<Heading fontWeight="semibold" fontSize="3xl" as="h2" mb="8">
				{__("Integrations", "magazine-blocks")}
			</Heading>
			<Stack
				bgColor="#FAFAFC"
				border="1px"
				borderColor="gray.200"
				borderRadius="lg"
				maxWidth="4xl"
				py="4"
				px="5"
			>
				<Stack gap="7">
					<FormTwoColumn
						label={__(
							"Date & Weather Embed API Key",
							"magazine-blocks"
						)}
						labelAlignStart
					>
						<Stack>
							<Input
								{...register("integrations.dateWeatherApiKey", {
									value: props.data?.["dateWeatherApiKey"],
								})}
								borderRadius="base"
							/>
						</Stack>
					</FormTwoColumn>
				</Stack>
				<Stack gap="7">
					<FormTwoColumn
						label={__("Latitude", "magazine-blocks")}
						labelAlignStart
					>
						<Stack>
							<Input
								{...register(
									"integrations.dateWeatherLatitude",
									{
										value: props.data?.[
											"dateWeatherLatitude"
										],
									}
								)}
								borderRadius="base"
							/>
						</Stack>
					</FormTwoColumn>
				</Stack>
				<Stack gap="7">
					<FormTwoColumn
						label={__("Longitude", "magazine-blocks")}
						labelAlignStart
					>
						<Stack>
							<Input
								{...register(
									"integrations.dateWeatherLongitude",
									{
										value: props.data?.[
											"dateWeatherLongitude"
										],
									}
								)}
								borderRadius="base"
							/>
						</Stack>
					</FormTwoColumn>
				</Stack>
				<Stack gap="7">
					<FormTwoColumn
						label={__("Unit", "magazine-blocks")}
						labelAlignStart
					>
						<Stack>
							<Select
								{...register("integrations.dateWeatherUnit", {
									value:
										props.data?.["dateWeatherUnit"] ||
										"imperial",
								})}
								bg="unset !important"
								borderColor="gray.200 !important"
								sx={{
									"&.chakra-select": {
										maxWidth: "full !important",
									},
								}}
							>
								<option value="imperial">
									{__("Fahrenheit", "magazine-blocks")}
								</option>
								<option value="metric">
									{__("Celsius", "magazine-blocks")}
								</option>
							</Select>
						</Stack>
					</FormTwoColumn>
				</Stack>
			</Stack>
		</Box>
	);
};

export default Integrations;
